// User Model
import { Model } from '@vuex-orm/core'

export default class ProductCategory extends Model {
    static entity = 'product-categories';

    static fields() {
        return {
            id: this.attr(null),
            title: this.attr(null),
            image: this.attr(null),
        }
    }
}
